const QCActivityActionTypes = {
	CLEAR_ERROR: "CLEAR_ERROR",
	// Fetch QC
	FETCH_CUBIC_START: "FETCH_CUBIC_START",
	FETCH_CUBIC_SUCCESS: "FETCH_CUBIC_SUCCESS",
	FETCH_CUBIC_FAILURE: "FETCH_CUBIC_FAILURE",
};

export default QCActivityActionTypes;
